export default __webpack_public_path__ + "static/4-72e38aa9421816a8bdfaf2648cbac11d.jpg";